import React from "react";

export default function Button({
  children,
  onClick,
  disabled = false,
  className = "",
  type = "button",
  bgColor = "bg-colorButton", // default background color
  textColor = "text-white",   // default text color
}) {
  return (
    <button
      type={type}
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
      className={`
        flex items-center justify-center
        ${bgColor} ${textColor}
        px-4 py-1 rounded text-sm  transition
        hover:opacity-90 active:scale-95
        ${disabled ? "opacity-50 cursor-not-allowed" : ""}
        ${className}
      `}
    >
      {children}
    </button>
  );
}
